import classNames from "classnames";
import { bool, func, number } from "prop-types";
import React, { Component } from "react";
import { connect } from "react-redux";
import { ConnectedRouter } from "react-router-redux";

import { history } from "store";

import { MAX_FAILED_TIMES } from "constants.js";
import MainContainer from "pages/_components/MainContainer";
import { selectors as configSelectors } from "reducers/config";
import { selectors as i18nSelectors } from "reducers/i18n";
import { actions as pushNotificationsActions } from "reducers/pushNotifications";
import { selectors as sessionSelectors } from "reducers/session";
import Routes from "routes/Routes";
/* eslint-disable react/jsx-filename-extension */
class App extends Component {
    static propTypes = {
        loading: bool,
        timesConfigFailed: number,
        timesI18nFailed: number,
        sessionFetching: bool,
        dispatch: func.isRequired,
    };

    static defaultProps = {
        loading: false,
        timesConfigFailed: 0,
        timesI18nFailed: 0,
        sessionFetching: false,
    };

    componentDidMount() {
        document.addEventListener("fcmTokenWasRefreshed", this.handleTokenReceived);
    }

    componentWillUnmount() {
        document.removeEventListener("fcmTokenWasRefreshed", this.handleTokenReceived);
    }

    handleTokenReceived = (event) => {
        const { dispatch } = this.props;
        const { fcmToken } = event.detail;
        if (fcmToken && fcmToken.length > 0) {
            dispatch(pushNotificationsActions.refreshToken(fcmToken));
        }
    };

    render() {
        const { loading, timesConfigFailed, timesI18nFailed, sessionFetching } = this.props;

        const serverError = timesConfigFailed >= MAX_FAILED_TIMES || timesI18nFailed >= MAX_FAILED_TIMES;

        if ((loading && !serverError) || sessionFetching) {
            return (
                <div className="view-page">
                    <div className="view-content">
                        <MainContainer showLoader className={classNames("main-container")} />
                    </div>
                </div>
            );
        }

        return (
            <ConnectedRouter history={history}>
                <Routes />
            </ConnectedRouter>
        );
    }
}

const mapStateToProps = ({ isLoading, ...state }) => {
    const configItems = configSelectors.getConfig(state) || {};
    // `!{}` is always false — require real keys so UX flags are not read as defaults (ARBCMFIMP-19874).
    const hasConfig = Object.keys(configItems).length > 0;

    return {
        loading: isLoading || !i18nSelectors.getMessages(state) || !hasConfig,
        timesConfigFailed: configSelectors.getTimesFailed(state),
        timesI18nFailed: i18nSelectors.getTimesFailed(state),
        sessionFetching: sessionSelectors.isFetching(state),
    };
};

export default connect(mapStateToProps)(App);
